import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=501768d6&scoped=true"
import script from "./binding.vue?vue&type=script&lang=js"
export * from "./binding.vue?vue&type=script&lang=js"
import style0 from "./binding.vue?vue&type=style&index=0&id=501768d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501768d6",
  null
  
)

export default component.exports